export default __webpack_public_path__ + "static/media/calendar.f0fda030.svg";